import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { HumanInteractionService } from '../../../services/human-interaction.service';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';

@Component({
  selector: 'app-business-process-invoke-list',
  templateUrl: './business-process-invoke-list.component.html',
  styleUrls: ['./business-process-invoke-list.component.css']
})
export class BusinessProcessInvokeListComponent implements OnInit {

  filterForm: FormGroup;
  userLockedQueueFilter: any;
  allInstancesQueueFilter: any;
  gridConfigs$ = new Observable<any[]>();
  queueConfig;
  pageConfig;
  viewType: InvokeListViewType;
  errorMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    private humanInteractionService: HumanInteractionService,
    private webClientConfig: WebClientConfigurationService
  ) { }

  ngOnInit() {
    this.viewType = InvokeListViewType.Grid;
    this.getPageConfig();
    this.createForm();
    this.getQueue();
    this.userLockedQueueFilter = this.setQueueFilter('locked');
    this.allInstancesQueueFilter = this.setQueueFilter('notLocked');
  }

  createForm() {
    this.filterForm = this.formBuilder.group({
      businessProcessId: null,
      columns: null,
      columnsComparisonType: null,
      customInteractionQueueConfigId: null,
      finalDate: null,
      initialDate: null,
      orderByColumnId: null,
      orderByStateModifyDate: false,
      orderDirection: 0,
      pageIndex: 0,
      pageSize: 0,
      stateId: null,
      stateLifeCycles: null,
      userLogon: null
    });
  }

  setQueueFilter(type: string): any {
    const filter = this.filterForm.getRawValue();
    if (type === 'locked') {
      filter.stateLifeCycles = [8 , 11];
      filter.userLogon = localStorage.getItem('userLogon');
    } else {
      filter.columns = [];
      filter.columnsComparisonType = 1;
      filter.stateLifeCycles = [7];
    }
    return filter;
  }

  getQueue() {
    this.errorMessage = '';
    this.gridConfigs$ = this.humanInteractionService.getInteractionQueue();
    this.gridConfigs$
      .subscribe( queue => {
        this.queueConfig = queue;
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  getPageConfig() {
    this.errorMessage = '';
    this.webClientConfig.getPageConfig()
      .subscribe(pageConfig => {
          this.pageConfig = pageConfig;
        },
        error1 => {
          this.errorMessage = error1;
        });
  }

  onClickChangeView(type: InvokeListViewType) {
    this.viewType = type;
  }
}

export enum InvokeListViewType {
  Grid = 1,
  Card = 2
}
